const Footer = () => {
    return (
        <>
            <div className="add">
                <i>Endereço: </i> Rua C-209 Qd. 526 Lt. 09/11 Sl. 06 - Jardim América - CEP 74270-220, Goiânia - GO
                <i>Telefone: </i> 62 9 8148-5673
            </div>
            <iframe className="cnt"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15285.538973692963!2d-49.28438!3d-16.707644!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5340bd3d46be9341!2sConectiva+Inform%C3%A1tica!5e0!3m2!1spt-BR!2sus!4v1471824120134"></iframe>
            <div id="footer">
                2019 Conectiva Informática | Todos direitos reservados
            </div>
        </>

    )
}

export default Footer;